import axios from 'axios';

export const USER_REGISTER = 'USER_REGISTER';
export const USER_LOGIN = 'USER_LOGIN';

export const CMS_BASE_URL = 'https://backend.her2manage.hk';//https://azds-cms.demo-uat.com'; //'https://medicaleducation.backend.yubis.net'; //'http://localhost:8000'; //

export function getAccount($body) {
  const request = axios.post(CMS_BASE_URL+'/api/getAccount', $body );
  return request;
}

export function updateAccount($body) {
  const request = axios.post(CMS_BASE_URL+'/api/updateAccount', $body );
  return request;
}

export function postPw($body) {
  const request = axios.post(CMS_BASE_URL+'/api/resetPw', $body );
  return request;
}

export function postGe($body) {
  const request = axios.post(CMS_BASE_URL+'/api/ge', $body );
  return request;
}

export function postAe($body) {
  const request = axios.post(CMS_BASE_URL+'/api/ae', $body );
  return request;
}

export function postAeItem($body) {
  const request = axios.post(CMS_BASE_URL+'/api/aeItem', $body );
  return request;
}

export function postCaseItem($body) {
  const request = axios.post(CMS_BASE_URL+'/api/cases', $body );
  return request;
}

export function postVideoItem($body) {
  const request = axios.post(CMS_BASE_URL+'/api/videos', $body );
  return request;
}

export function postSlideItem($body) {
  const request = axios.post(CMS_BASE_URL+'/api/slides', $body );
  return request;
}

export function postNewsItem($body) {
  const request = axios.post(CMS_BASE_URL+'/api/news', $body );
  return request;
}
export function postSearch($body) {
  const request = axios.post(CMS_BASE_URL+'/api/search', $body );
  return request;
}

export function postLogin($body) {
  const request = axios.post(CMS_BASE_URL+'/api/login', $body );
  return request;
}

export function postRegister($body) {
  const request = axios.post(CMS_BASE_URL+'/api/register', $body );
  return request;
}

export function postTerms($body) {
  const request = axios.post(CMS_BASE_URL+'/api/terms', $body );
  return request;
}






